// @flow
import React from 'react';

import { Select } from '@duxton-web/ui';
import { colorContentPlaceholder } from '@duxton-web/design-tokens/themes/light';

import MultiSelectDropdown from 'omega-rtc/components/form/ucd/common/MultiSelectDropdown';
import { AUDIENCE_TYPES } from 'omega-rtc/constants/ucd';

const audienceTypeOptions = Object.keys(AUDIENCE_TYPES).map((key) => {
  return { label: AUDIENCE_TYPES[key], value: key };
});

const AudienceTypeSelector = ({
  multiple,
  initialValue,
  onChange,
  ...props
}) => {
  if (multiple) {
    return (
      <MultiSelectDropdown
        width={'100%'}
        height={'43px'}
        menuWidth={'100%'}
        placeholder="Audience Type"
        multiValuePlaceholder="Multiple Audience Types"
        initialValue={initialValue}
        options={audienceTypeOptions}
        onChange={onChange}
        buttonStyle={{
          borderRadius: '14px',
        }}
        placeholderStyle={{
          color: colorContentPlaceholder,
        }}
        {...props}
      />
    );
  }

  return (
    <Select
      placeholder="Select Audience Type"
      size="default"
      options={audienceTypeOptions}
      onChange={onChange}
      {...props}
    />
  );
};

export default AudienceTypeSelector;
